module.exports = __webpack_public_path__ + "static/media/repeat-alt.a32ab701.svg";